<template>
  <div v-if="histories">
    <b-list-group :key="history.model.gli" v-for="history in histories" class="mb-2">
      <!-- the record the message is about, when it has one, is first and is
           marked - the sender should not have to work out which of five
           recently-viewed records this message concerns -->
      <b-list-group-item :variant="history.model.referenced ? 'primary' : 'info'" class="d-flex">
        <div class="mr-auto">{{ history.model.gli }} - {{ history.model.description }}</div>
        <b-badge variant="light" v-if="history.model.referenced" class="my-auto ml-2">This message</b-badge>
      </b-list-group-item>
      <!-- attaching the same document twice is legitimate (a revised invoice),
           so a document already attached is marked rather than removed -->
      <b-list-group-item @click="add(doc)" button :key="doc.key" v-for="doc in history.documents"
                         :class="{'text-muted': attached(doc)}">
        <font-awesome-icon :icon="attached(doc) ? 'fa-solid fa-check' : 'fa-solid fa-plus'" class="mr-2"/>
        {{ doc.label }}
      </b-list-group-item>
    </b-list-group>

    <b-alert v-if="!histories.length" show variant="light" class="small text-muted mb-0">
      Nothing to attach. Open an order, quote, PO or bid and it will be offered here.
    </b-alert>
  </div>
</template>

<script>
// Documents a recently-viewed record can produce, offered for attachment.
//
// The sibling of files-history: that one copies a file somebody already
// uploaded, this one has the server render the paper - the invoice for the
// order you were just looking at - and attaches the PDF it produced. Once
// attached it is an ordinary file on the record, so the Attachments tab lists
// and removes it like any other.
export default {
  name: "documents-history",

  data() {
    return {
      histories: null,
      done: []
    }
  },

  props: {
    // where to LIST from. Deliberately not tied to a record: browsing what
    // could be attached should cost nothing
    url: String,
    /*
     * How to attach one. A function rather than a URL because the caller may
     * have nothing to attach to yet - the mail compose window creates its
     * draft here, on the first attach, and not when the tab is opened.
     *
     * Receives the document row; resolves when it is attached, throws to leave
     * the row unticked.
     */
    attach: {type: Function, required: true},
  },

  mounted() {
    this.refresh()
  },

  methods: {
    async refresh() {
      this.histories = await this.asyncAction(this.url, 'GET')
    },

    attached(doc) {
      return this.done.includes(this.id(doc))
    },

    id(doc) {
      return `${doc.model}:${doc.id}:${doc.key}`
    },

    async add(doc) {
      await this.attach(doc)

      this.done = [...this.done, this.id(doc)]
      this.toast(`${doc.label} attached`)
      this.$emit('attached')
    }
  }
}
</script>
